import gameNames from '../../hub/data/GameIds';

const initialState = {
  selectedItem: null,
  itemIsCorrect: false,
  // correct answers within a round
  correctItems: 0,
  // wrong answers within a round
  wrongItems: 0,
};

const levelReducer = (state = initialState, action) => {
  if (action.gameId !== gameNames.SUPER_MATCH) {
    return state;
  }

  switch (action.type) {
    case 'INIT_LEVEL':
      return initialState;
    case 'PICK_AN_ITEM':
      return { ...state, selectedItem: action.payload.selectedItem };
    case 'ITEM_IS_CORRECT':
      return { ...state, itemIsCorrect: action.payload.itemIsCorrect };
    case 'INCREMENT_CORRECT_ITEMS_COUNTER':
      return { ...state, correctItems: state.correctItems + 1 };
    case 'INCREMENT_WRONG_ITEMS_COUNTER':
      return { ...state, wrongItems: state.wrongItems + 1, correctItems: 0 };
    case 'RESET_SELECTED_ITEM':
      return {
        ...state,
        selectedItem: null,
        itemIsCorrect: false,
        selectAnimationPlayed: false,
      };
    default:
      return state;
  }
};

export default levelReducer;
